import { render, staticRenderFns } from "./addAiEventAlartDialog.vue?vue&type=template&id=4a0a6b26&scoped=true"
import script from "./addAiEventAlartDialog.vue?vue&type=script&lang=js"
export * from "./addAiEventAlartDialog.vue?vue&type=script&lang=js"
import style0 from "./addAiEventAlartDialog.vue?vue&type=style&index=0&id=4a0a6b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0a6b26",
  null
  
)

export default component.exports